// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__190yP","productName":"Table_productName__2J27x"};